import CreateProposal from "./CreateProposal";

export default CreateProposal;
